export default __webpack_public_path__ + "static/media/Stalker's Armbands of the Silent Kill.45430927.jpg";